import { List, ListItem, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { Case } from '../../../../types/Case/Case.type';
import { ListCaseItem } from './ListCaseItem';

interface ListViewProps {
  activeSort: string;
  cases: Case[];
  fetchNextPage: () => void;
  loadingNextPage: boolean;
  hasNextPage: boolean;
}

export const ListView = ({ activeSort, cases, fetchNextPage, loadingNextPage, hasNextPage }: ListViewProps) => {
  const { ref, inView } = useInView();

  useEffect(() => {
    if (inView && fetchNextPage && !loadingNextPage) {
      fetchNextPage();
    }
  }, [inView, fetchNextPage, loadingNextPage]);

  return (
    <div style={{ overflowY: 'auto', maxHeight: '620px', minHeight: '620px', marginTop: '32px', marginBottom: '32px' }}>
      <List>
        {cases?.map((caseData) => (
          <ListItem key={caseData.id} divider sx={{ paddingX: 0 }}>
            <ListCaseItem caseData={caseData} activeSort={activeSort} />
          </ListItem>
        ))}

        {hasNextPage && <div ref={ref} style={{ height: '1px', width: '100%' }}></div>}

        {loadingNextPage && (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '16px 0' }}>
            <Typography
              variant='caption'
              sx={{
                color: '#a0aec0',
              }}
            >
              Loading more cases...
            </Typography>
          </div>
        )}
      </List>
    </div>
  );
};
